import { ReactNode } from "react";
import { Redirect } from "wouter";
import { useAuth } from "@/hooks/use-auth";

interface CompanyUserOnlyRouteProps {
  children: ReactNode;
}

export function CompanyUserOnlyRoute({ children }: CompanyUserOnlyRouteProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00444C]"></div>
      </div>
    );
  }

  // Redirect platform admins based on the route they're trying to access
  if (user && user.role === "admin") {
    // Allow admins to view specific assessments in the workflow
    if (window.location.pathname.startsWith("/workflow/")) {
      return <>{children}</>;
    }
    // If they're trying to access /dashboard, redirect to /admin/dashboard
    if (window.location.pathname === "/dashboard") {
      return <Redirect to="/admin/dashboard" />;
    }
    // If they're trying to access /assessments, redirect to /admin/assessments
    if (window.location.pathname === "/assessments") {
      return <Redirect to="/admin/assessments" />;
    }
    // Default redirect to admin dashboard
    return <Redirect to="/admin/dashboard" />;
  }

  return <>{children}</>;
}
